module.exports = __webpack_public_path__ + "img/patent_image15.9dbd9444.png";